import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, usePutApi, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { NaviSample, NaviSampleForm, NaviSampleSearchForm } from 'entities/navi_sample'

type NaviSamplesResponse = PagingResponse & {
    results: NaviSample[]
}

export function useFetchNaviSamplesApi(searchForm: Form<NaviSampleSearchForm>): IndexApiSet<NaviSamplesResponse> & { execute: () => void } {
    const apiPath = 'navi_samples/'
    const api = useIndexApi<NaviSamplesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

type NaviSampleResponse = BaseResponse & NaviSample

export function useFetchNaviSampleApi(): ApiSet<NaviSampleResponse> & { execute: (id: number) => void } {
    const api = useShowApi<NaviSampleResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number): void => {
        const apiPath = `navi_samples/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

export function usePutNaviSampleApi(): ApiSet<BaseResponse> & { execute: (form: Form<NaviSampleForm>) => void } {
    const apiSet = usePutApi<BaseResponse, NaviSampleForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<NaviSampleForm>) => {
        const apiPath = `navi_samples/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutNaviSamplesApi(): ApiSet<BaseResponse> & { execute: (form: Form<NaviSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, NaviSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<NaviSampleForm[]>) => {
        const apiPath = `navi_samples/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
export function usePutNaviSampleResultStatusApi(): ApiSet<BaseResponse> & { execute: (form: Form<NaviSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, NaviSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<NaviSampleForm[]>) => {
        const apiPath = `navi_samples/update_result_status/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function usePutNaviSampleResultConfirmApi(): ApiSet<BaseResponse> & { execute: (form: Form<NaviSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, NaviSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<NaviSampleForm[]>) => {
        const apiPath = `navi_samples/update_result_confirm/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}